import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Footer from '@/components/Footer';
import { useOutlet } from 'react-router';
import LandingNavBar from '../landing/NavBar';
import ContainerStack from '../landing/ContainerStack';
import { Box } from '@chakra-ui/react';
function LegalLayout(param) {
    var children = param.children;
    var outlet = useOutlet();
    if (children == null && outlet == null) {
        throw new Error('LegalLayout requires children or an Outlet');
    }
    return /*#__PURE__*/ _jsx(Box, {
        width: "100%",
        backgroundColor: "backgroundSecondary",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        children: /*#__PURE__*/ _jsxs(ContainerStack, {
            children: [
                /*#__PURE__*/ _jsx(LandingNavBar, {
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "backgroundPrimary"
                }),
                children !== null && children !== void 0 ? children : outlet,
                /*#__PURE__*/ _jsx(Footer, {
                    backgroundColor: "backgroundPrimary"
                })
            ]
        })
    });
}
export default LegalLayout;
